import ModulesList from './Settings/Modules/ModulesList'

export default {
    namespaced: true,
    modules: {
        ModulesList: ModulesList
    }
}